import { useState, memo } from 'react'
import { Button, Checkbox } from '@leroy-merlin-br/backyard-react-ui'

import * as S from './styled'

const Footer = ({
  onClick,
  onClose
}) => {
  const [checked, setChecked] = useState(false)

  return (
    <S.Footer>
      <Checkbox
        id="crossServices"
        value="checked"
        onChange={() => setChecked((status) => !status)}
        isChecked={checked}
      >
        Aceito as condições do serviço
      </Checkbox>
      <S.ButtonsContainer>
        <Button onClick={onClose} variant="outline" color="gray">
          Voltar
        </Button>
        <Button
          onClick={onClick}
          isDisabled={!checked}
          color={(checked ? 'green' : 'gray')}
        >
          Aceitar
        </Button>
      </S.ButtonsContainer>
    </S.Footer>
  )
}

export default memo(Footer)
